import React, { useEffect, useState } from "react";
import { GitBranch } from "lucide-react";
import { PageHeader } from "@/components/Layout";
import { Chip, EmptyState } from "@/components/Bits";
import api from "@/lib/api";

export default function Workflows() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/workflows").then((r) => setRows(r.data)); }, []);

  return (
    <div>
      <PageHeader title="Automation · Workflow Templates" subtitle="Steps auto-generate tasks when an order is created" />
      <div className="p-8 space-y-5">
        {rows.length === 0 ? <EmptyState icon={GitBranch} title="No workflows" /> : rows.map((w) => (
          <div key={w.id} data-testid={`workflow-${w.id}`} className="bg-[#121212] border border-white/10 rounded-sm p-6">
            <div className="flex items-center justify-between mb-4">
              <div><h3 className="font-display text-lg font-medium">{w.name}</h3><p className="text-xs text-zinc-500">{w.brand || "All brands"} · {w.order_type} · {w.steps.length} steps</p></div>
              <Chip className="bg-[#00FF66]/10 border-[#00FF66]/30 text-[#00FF66]">{w.status}</Chip>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {w.steps.map((s, i) => (
                <React.Fragment key={s.key}>
                  <div className="border border-white/10 bg-[#0a0a0a] rounded-sm px-3 py-1.5">
                    <div className="text-xs text-zinc-200">{s.title}</div>
                    {s.team && <div className="text-[9px] font-mono uppercase tracking-wider text-zinc-600">{s.team}{s.depends_on?.length ? ` · after ${s.depends_on.length}` : ""}</div>}
                  </div>
                  {i < w.steps.length - 1 && <span className="text-zinc-700">→</span>}
                </React.Fragment>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
